import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { t } from '../utils/translation';

const Footer = ({ theme, language }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={`relative transition-colors duration-300 ${
      theme === 'dark' 
        ? 'bg-black' 
        : 'bg-gray-100'
    } pt-16 pb-20 md:pb-6`}>
      <div className="absolute top-0 left-0 right-0 h-[2px] footer-glow"></div>
      <div className="absolute bottom-0 left-0 right-0 h-[2px] footer-glow-bottom"></div>
      
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          <div>
            <h2 className="text-2xl font-bold text-red-600 mb-4">Qingshun Tech</h2>
            <p className={`text-sm mb-4 ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>
              Suzhou Qingshun Electronics Technology Co., Ltd.
            </p>
            <p className={`text-sm ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>
              Leading connector manufacturer providing premium quality alternatives at 50-70% cost savings.
            </p>
          </div>

          <div>
            <h3 className={`text-lg font-bold mb-6 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/brand-alternatives" className={theme === 'dark' ? 'text-gray-400 hover:text-red-400 transition text-sm' : 'text-gray-600 hover:text-red-600 transition text-sm'}>Brand Alternatives</Link>
              </li>
              <li>
                <Link to="/manufacturing" className={theme === 'dark' ? 'text-gray-400 hover:text-red-400 transition text-sm' : 'text-gray-600 hover:text-red-600 transition text-sm'}>Manufacturing</Link>
              </li>
              <li>
                <Link to="/industries" className={theme === 'dark' ? 'text-gray-400 hover:text-red-400 transition text-sm' : 'text-gray-600 hover:text-red-600 transition text-sm'}>Industries</Link>
              </li>
              <li>
                <Link to="/custom-solutions" className={theme === 'dark' ? 'text-gray-400 hover:text-red-400 transition text-sm' : 'text-gray-600 hover:text-red-600 transition text-sm'}>Custom Solutions</Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className={`text-lg font-bold mb-6 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <Phone className="w-4 h-4 mr-3 mt-0.5 flex-shrink-0 text-red-600" />
                <div>
                  <p className={`text-sm ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>WhatsApp</p>
                  <p className={`text-sm ${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}`}>+86 13913225243</p>
                </div>
              </li>
              <li className="flex items-start">
                <Mail className="w-4 h-4 mr-3 mt-0.5 flex-shrink-0 text-red-600" />
                <div>
                  <p className={`text-sm ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>Email</p>
                  <p className={`text-sm ${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}`}>tony@qsconn.com</p>
                </div>
              </li>
              <li className="flex items-start">
                <Phone className="w-4 h-4 mr-3 mt-0.5 flex-shrink-0 text-red-600" />
                <div>
                  <p className={`text-sm ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>Phone</p>
                  <p className={`text-sm ${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}`}>+86 18013289913</p>
                </div>
              </li>
            </ul>
          </div>

          <div>
            <h3 className={`text-lg font-bold mb-6 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>Location</h3>
            <div className="flex items-start">
              <MapPin className="w-4 h-4 mr-3 mt-0.5 flex-shrink-0 text-red-600" />
              <p className={`text-sm ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>
                2526 Huayuan Road, Zhangpu Town Kunshan City, Suzhou City Jiangsu Province, China
              </p>
            </div>
          </div>
        </div>

        <div className={`pt-8 mt-8 ${theme === 'dark' ? 'border-t border-gray-800' : 'border-t border-gray-300'}`}>
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className={`text-sm mb-4 md:mb-0 ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>
              © {currentYear} Suzhou Qingshun Electronics Technology Co., Ltd. All rights reserved.
            </p>
            <div className="flex gap-4">
              <span className={`text-xs px-4 py-2 rounded-full border ${theme === 'dark' ? 'border-gray-700 text-gray-400' : 'border-gray-400 text-gray-600'}`}>
                ISO 9001 Certified
              </span>
              <span className={`text-xs px-4 py-2 rounded-full border ${theme === 'dark' ? 'border-gray-700 text-gray-400' : 'border-gray-400 text-gray-600'}`}>
                RoHS Compliant
              </span>
              <span className={`text-xs px-4 py-2 rounded-full border ${theme === 'dark' ? 'border-gray-700 text-gray-400' : 'border-gray-400 text-gray-600'}`}>
                14+ Years Experience
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;